module.exports = __webpack_public_path__ + "img/schedule_page2.b874fbbf.jpg";